import "../styles/DefaultLayout.css";
import splitPosLogo from "../assets/splitPosLogo2.png";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  CloseOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import { Layout } from "antd";
import React, { useEffect, useState } from "react";
import RoleWiseSidebar from "./RoleWiseSidebar";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  getStoreIdAction,
  storeDataAction,
  userDataAction,
  userRoleAction,
} from "../redux/actions/userAction";
import {
  merchantDataAction,
  purchaseOrderPlaceDataAction,
  statusOfOrderDataValue,
} from "../redux/actions/merchantAction";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle } from "@fortawesome/free-regular-svg-icons";
import { getReq, postReq, postReqwithoutHeader } from "../utils/ApiClient";
import {
  clearAuth,
  getUserData,
  setUserData,
  setUserToken,
} from "../utils/utils";
import { useMediaQuery } from "react-responsive";
import { toast } from "react-toastify";
const DefaultLayout = (props) => {
  const { Header, Sider, Content } = Layout;
  const [collapsed, setCollapsed] = useState(false);
  /* `showSide` is INVERTED from what the name says: Responsive.css:838 and
     :2159 read `.showSide .leftSidebar { display: none }`, so the drawer is
     visible when this is FALSE. See MIGRATION.md 1.5g, where the same trap
     produced a false negative during a repro.

     It initialised to `false`, which meant the drawer was OPEN on first paint
     at every width up to 1024px - a fixed, opaque, 260px navy panel over the
     page, with the hamburger acting as a close button. Seeded from the same
     1024px boundary the CSS uses (and the same one `isMobile` below uses) so
     the drawer starts CLOSED on phone and tablet. Above 1024px the value is
     inert: every rule keyed on `.showSide` lives inside a max-width: 1024px
     query or one of the dead min-device-width ones, so desktop is untouched. */
  const [showSide, setShowSide] = useState(
    () =>
      typeof window !== "undefined" &&
      window.matchMedia("(max-width: 1024px)").matches,
  );
  const [showPin, setShowPin] = useState(false);
  const [dropdownMenu, setDropdownMenu] = useState(false);
  const userName = useSelector((store) => store.userReducer.userData);
  const storeRecord = useSelector((store) => store.userReducer.storeData);
  const storeObject = useSelector(
    (store) => store.userReducer.storeIdByMerchant,
  );
  const currentStore =
    storeRecord && storeRecord.find((item) => item._id === storeObject._id);
  const role = useSelector((store) => store.userReducer.userRole);
  const superAdminData = useSelector(
    (store) => store.userReducer.superAdminData,
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const logOut = () => {
    if (role === "employee") {
      navigate("/");
      // navigate("/emp-login");
    } else {
      navigate("/");
      // navigate("/sign-in");
    }
    clearAuth();
    localStorage.clear();
  };
  const isMobile = useMediaQuery({ maxWidth: 1024 });
  const { pathname } = useLocation();

  useEffect(() => {
    if (isMobile) {
      setShowSide(true);
    }
    // eslint-disable-next-line
  }, [pathname]);

  const handleChange = (e) => {
    const selectedStoreId = e.target.value;
    const selectedStore = storeRecord?.find(
      (store) => store._id === selectedStoreId,
    );
    dispatch(getStoreIdAction(selectedStore));
  };
  const getStoreList = async () => {
    const apidata = getUserData();
    if (apidata?.role === "super-admin" || apidata?.role === "admin") {
      try {
        const response = await getReq("getAllStoreList", navigate);
        const { result, status } = response.data;
        if (status === 200) {
          dispatch(storeDataAction(result));
        }
      } catch (error) {
        toast.error("Connection Error", {
          theme: "colored",
          autoClose: 950,
        });
      }
    } else {
      const apidata = getUserData();
      const reqBody = {
        agentId: apidata?._id,
      };
      try {
        const response = await postReq(`web/assignedStores`, reqBody);
        const { result, status } = response.data;
        if (status === 200) {
          dispatch(storeDataAction(result));
        }
      } catch (error) {
        console.warn(error);
      }
    }
  };
  const getMerchantList = async () => {
    try {
      const apidata = getUserData();
      const { _id } = apidata;
      const response = await getReq(`getMerchantList?createdById=${_id}`);
      if (response?.data?.status === 200) {
        dispatch(merchantDataAction(response?.data?.result));
      } else {
        toast.error(response?.data?.message, {
          theme: "colored",
          autoClose: 950,
        });
      }
    } catch (error) {
      toast.error("Connection Error", {
        theme: "colored",
        autoClose: 950,
      });
    }
  };

  //Back to Super Admin dashboard
  const backToAdminLogin = async () => {
    const reqBody = {
      email: superAdminData.email,
      password: superAdminData.password,
    };
    const response = await postReqwithoutHeader(`web/login`, reqBody);
    const { token, result, status } = response.data;
    if (status === 200) {
      let { role } = result;
      setUserToken(token);
      setUserData(result);
      dispatch(userRoleAction(role));
      dispatch(userDataAction(result));
      navigate("/dashboard");
      dispatch(userRoleAction(role));
      dispatch(statusOfOrderDataValue(false));
      dispatch(purchaseOrderPlaceDataAction([]));
      getMerchantList();
      getStoreList();
    }
  };
  return (
    <Layout className={`${showSide ? "showSide" : ""}`}>
      {/* Mobile drawer backdrop. Carried-forward blocker #2 in MIGRATION.md:
          `#overlay` was referenced by Responsive.css:847 and :856 but NO
          element with that id existed anywhere in src/, so there has never
          been a backdrop or a close-on-backdrop-click. This is that element,
          rendered from React rather than resurrecting the dead CSS (which also
          carries an `.ant-layou` typo and paints opaque #1a1a1a rather than a
          scrim).

          `!showSide` because the flag is inverted - see the useState above.

          The hide boundary is min-[1025px], not lg: or xl:, to match the CSS
          exactly: the drawer behaves as an overlay for the whole range the
          `max-width: 768px` and `768-1024` queries cover, and the sidebar only
          docks at 1025px. A named breakpoint would have left a band with
          either a backdrop over a docked sidebar or an overlay with none. */}
      {!showSide && (
        <div
          aria-hidden="true"
          onClick={() => setShowSide(true)}
          className="tw-fixed tw-inset-0 tw-z-drawerBackdrop tw-bg-black/50 min-[1025px]:tw-hidden"
        />
      )}
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        /* z-index 3 -> the `drawer` token (50), and the backdrop above takes
           `drawerBackdrop` (40). This is a real stacking conflict, not
           housekeeping: the backdrop has to sit ABOVE `.topHeader` (z-2, so it
           scrims the header too, as a modal drawer should) and BELOW this
           sidebar - and there is no integer between 2 and 3. Verified nothing
           else lands in the vacated band: every table is capped at z-1 inside
           its `.table-responsive` stacking context (increment 1.5f), the
           header's `.cstm-overlay-dropdown` at z-8 is confined by `.topHeader`
           being a stacking context itself, Loader is z-200 so it still covers
           the drawer, and the vendor modal floor is 1000. */
        className="leftSidebar !tw-w-[260px] !tw-max-w-[260px] !tw-basis-[260px] tw-shadow-[3px_0_10px_#5c5c5c63] tw-min-h-screen tw-fixed tw-z-drawer"
      >
        <div className="text-center">
          <img
            src={splitPosLogo}
            alt="splitPosLogo"
            style={{
              width: "180px",
              margin: "10px auto 0",
              textAlign: "center",
            }}
          />
        </div>
        <div className="logo">
          <button
            className="remove-sidebar"
            onClick={() => setShowSide((preValue) => !preValue)}
          >
            <CloseOutlined />
          </button>
        </div>
        <RoleWiseSidebar role={role} />
      </Sider>
      <Layout className="site-layout">
        <Header className="topHeader tw-bg-white tw-text-brand-navy tw-flex tw-items-center tw-justify-between tw-px-5 tw-sticky tw-top-0 tw-z-[2]">
          <div className="d-flex align-items-center gap-3">
            <button
              className="add-sidebar"
              onClick={() => setShowSide((preValue) => !preValue)}
            >
              <MenuOutlined />
            </button>
            {React.createElement(
              collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
              {
                // NOTE: display is scoped to md+ on purpose. Responsive.css
                // hides .side-trigger below 768px (`display:none`) because the
                // ☰ .add-sidebar button is the mobile toggle. An unconditional
                // `flex` here overrode that and produced two hamburger icons
                // on mobile.
                className:
                  "trigger custmTrigr side-trigger tw-text-[1.6rem] md:tw-flex md:tw-flex-row-reverse md:tw-items-center md:tw-gap-[11px]",
                onClick: () =>
                  isMobile ? setCollapsed(false) : setCollapsed(!collapsed),
              },
            )}
            <div>
              {role === "super-merchant" && (
                <button
                  onClick={backToAdminLogin}
                  className="edit-btn tw-px-[11px] tw-py-[6px] tw-flex tw-items-center tw-h-[42px] tw-gap-[7px] tw-bg-brand-navy tw-text-white tw-rounded-[7px]"
                >
                  <i className="fa fa-backward" aria-hidden="true" />
                  <span>Back</span>
                </button>
              )}
            </div>
          </div>
          {(role === "merchant" || role === "super-merchant") &&
            storeRecord && (
              <div className="storeBox customStoreBox">
                <label className="storeNameLabel tw-pr-[11px] tw-text-base tw-font-semibold">
                  Store Name
                </label>
                <select
                  name="storeId"
                  className="select-custom selectDrop"
                  value={currentStore?._id}
                  onChange={handleChange}
                  autoComplete="new-storeId"
                >
                  {storeRecord && storeRecord?.length > 0 ? (
                    storeRecord?.map((item, index) => {
                      return (
                        <option value={item._id} key={index}>
                          {item?.storeName}
                        </option>
                      );
                    })
                  ) : (
                    <option value="">No Store Found!</option>
                  )}
                </select>
              </div>
            )}
          <div className="d-flex align-items-center gap-3">
            <div className="userProfile">
              <div className="dropdown">
                <span
                  className="dropdown-toggle"
                  type="button"
                  onClick={() => setDropdownMenu(!dropdownMenu)}
                >
                  <span className="iconDrdropdown">
                    <FontAwesomeIcon icon={faUserCircle} />
                  </span>
                  {role === "employee" ? (
                    <span>{userName?.name}</span>
                  ) : (
                    <span>
                      {userName?.firstName?.charAt(0).toUpperCase() +
                        userName?.firstName?.slice(1)}{" "}
                      {userName?.lastName?.charAt(0).toUpperCase() +
                        userName?.lastName?.slice(1)}
                    </span>
                  )}
                </span>
                <ul
                  className={`${
                    dropdownMenu ? "show" : ""
                  } dropdown-menu cstmdropdown-menu`}
                >
                  <li key={1} onClick={() => setDropdownMenu(!dropdownMenu)}>
                    <Link className="dropdown-item" to="/usersetting">
                      Settings
                    </Link>
                  </li>
                  {(role === "merchant" || role === "super-merchant") && (
                    <li
                      onClick={() => {
                        setShowPin((prev) => !prev);
                      }}
                    >
                      <span>
                        <span className="dropdown-item">
                          PIN:
                          {showPin ? (
                            <span>{userName?.merchantPIN}</span>
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="44"
                              height="44"
                              viewBox="0 0 24 24"
                              strokeWidth="1.5"
                              stroke="#2c3e50"
                              fill="none"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path
                                stroke="none"
                                d="M0 0h24v24H0z"
                                fill="none"
                              />
                              <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                              <path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6" />
                            </svg>
                          )}
                        </span>
                      </span>
                    </li>
                  )}
                  <li key={2} onClick={() => setDropdownMenu(!dropdownMenu)}>
                    <button onClick={logOut} className="dropdown-item">
                      Logout
                    </button>
                  </li>
                  <div
                    className="cstm-overlay-dropdown tw-fixed tw-z-[8] tw-w-full tw-h-screen tw-bg-transparent tw-left-0 tw-top-0"
                    onClick={() => setDropdownMenu(false)}
                  ></div>
                </ul>
              </div>
            </div>
          </div>
        </Header>
        {/* APP-WIDE change, below md only: the shell's gutters were flat at
            every width (12px margin + 16px padding per side), so at 375px they
            ate 56px - 15% of the viewport - before any page had drawn
            anything, and the Dashboard's own 20px sat inside that. Halved
            below 768px; md and up is byte-identical to before. */}
        <Content className="site-layout-background tw-bg-white tw-mt-[10px] tw-mx-3 tw-mb-0 tw-p-[10px_16px] tw-min-h-[380px] max-md:tw-mx-1.5 max-md:tw-px-2">
          {props?.children}
        </Content>
      </Layout>
    </Layout>
  );
};
export default DefaultLayout;
